import React from 'react';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { Root } from '../styles';
var SwitchInput = function (props) {
    var id = props.id, caption = props.caption, value = props.value, _a = props.size, size = _a === void 0 ? 'small' : _a, _b = props.disabled, disabled = _b === void 0 ? false : _b, _c = props.onChange, onChange = _c === void 0 ? undefined : _c;
    var onValueChange = function (e) {
        var _a;
        if (onChange) {
            var val = (_a = e === null || e === void 0 ? void 0 : e.target) === null || _a === void 0 ? void 0 : _a.checked;
            if (Number.isInteger(value)) {
                onChange(val ? 1 : 0);
            }
            else {
                onChange(val);
            }
        }
    };
    return (React.createElement(Root, { size: size, style: { margin: '0 5px' } },
        React.createElement(FormControlLabel, { control: React.createElement(Switch, { checked: !!value, onChange: onValueChange, name: id, color: "primary", disabled: disabled }), label: caption })));
};
SwitchInput.defaultProps = {
    size: 'small',
    disabled: false,
    onChange: undefined,
};
export default SwitchInput;
//# sourceMappingURL=SwitchInput.js.map